import { AutogenModelBonusCodeLookup, AutogenRowBonusCodeLookup } from "./autogen/AutogenModelBonusCodeLookup";

export class ModelBonusCodeLookup extends AutogenModelBonusCodeLookup<RowBonusCodeLookup> {
	constructor() {
		super(RowBonusCodeLookup);
	}
}

export class RowBonusCodeLookup extends AutogenRowBonusCodeLookup {
}